exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.root[data-v-78671096] {\n  height: 100%;\n}\n", ""]);

// exports
